export default __webpack_public_path__ + "static/media/tap-here-ios-18-ar.fb2d7ba7.png";